'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef } from 'react';
import { AppVideo } from '@/app/components/media/app-video';
import { type IntroVideoProps } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/intro-engine-reveal/intro-video/types';
import { isAutoplayBlockedError } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/shared/autoplay';
import { useVideoPreload } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/shared/useVideoPreload';
import { SPARTAN_ENGINE_HERO_TRACKING } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/tracking';
import { cn } from '@/app/utils/cn';
import { safeCall } from '@/app/utils/safeCall';
export const IntroVideo = t0 => {
  const $ = _c(27);
  const {
    src,
    coverSrc,
    coverAlt,
    paused,
    className,
    onVideoEnded,
    onVideoReady,
    onVideoPlaying,
    onVideoError,
    onPlayBlocked,
    onVideoElement,
    onCoverReady
  } = t0;
  const videoRef = useRef(null);
  const {
    src: resolvedSrc,
    isResident
  } = useVideoPreload(src);
  let t1;
  if ($[0] !== onCoverReady) {
    t1 = () => safeCall(onCoverReady);
    $[0] = onCoverReady;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== coverAlt || $[3] !== coverSrc || $[4] !== t1) {
    t2 = {
      src: coverSrc,
      alt: coverAlt,
      sizes: "70vw",
      fetchPriority: "high",
      onLoad: t1
    };
    $[2] = coverAlt;
    $[3] = coverSrc;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const poster = t2 as const;
  let t3;
  if ($[6] !== onVideoReady) {
    t3 = video => {
      if (!video) {
        return;
      }
      videoRef.current = video;
      safeCall(onVideoReady, video);
    };
    $[6] = onVideoReady;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleReady = t3;
  let t4;
  if ($[8] !== onVideoError) {
    t4 = () => {
      safeCall(onVideoError, videoRef.current?.error ?? new Error("Video failed to load"));
    };
    $[8] = onVideoError;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleError = t4;
  let t5;
  if ($[10] !== onPlayBlocked) {
    t5 = error => {
      if (isAutoplayBlockedError(error)) {
        safeCall(onPlayBlocked);
      }
    };
    $[10] = onPlayBlocked;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handlePlayRejected = t5;
  const t6 = resolvedSrc ?? src;
  const t7 = !resolvedSrc;
  const t8 = !isResident;
  let t9;
  if ($[12] !== className) {
    t9 = cn("z-60", className);
    $[12] = className;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = onVideoError ? handleError : undefined;
  let t11;
  if ($[14] !== handlePlayRejected || $[15] !== handleReady || $[16] !== onVideoElement || $[17] !== onVideoEnded || $[18] !== onVideoPlaying || $[19] !== paused || $[20] !== poster || $[21] !== t10 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t11 = <AppVideo priority={true} poster={poster} video={t6} preventLoadVideo={t7} autoplay={true} paused={paused} preload="auto" waitForFullBuffer={t8} className={t9} onReady={handleReady} onVideoEnded={onVideoEnded} onVideoPlaying={onVideoPlaying} onVideoError={t10} onPlayRejected={handlePlayRejected} onElementMount={onVideoElement} testId={SPARTAN_ENGINE_HERO_TRACKING.introVideo} />;
    $[14] = handlePlayRejected;
    $[15] = handleReady;
    $[16] = onVideoElement;
    $[17] = onVideoEnded;
    $[18] = onVideoPlaying;
    $[19] = paused;
    $[20] = poster;
    $[21] = t10;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};